import { render } from "./ImagePage.vue?vue&type=template&id=44809bb6&scoped=true"
import script from "./ImagePage.vue?vue&type=script&lang=js"
export * from "./ImagePage.vue?vue&type=script&lang=js"

import "./ImagePage.vue?vue&type=style&index=0&id=44809bb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44809bb6"]])

export default __exports__